import React from 'react';

function SocialIcon(props) {
    const {link, icon, label, onClickTrack} = props;
    
    const handleClick = () => {
        if (onClickTrack) {
            onClickTrack();
        }
    };
    
    return (
        <a target="_blank" aria-label={label}
           rel="noopener noreferrer" href={link} onClick={handleClick}>
            <i className={icon} aria-hidden="true"/>
        </a>
    );
}

export default SocialIcon;